<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORES.PAYMENT_METHODS_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-order-details-general-payment__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'ORDERS.ORIGINAL_CARD_ID_LABEL'"
      [content]="
        order?.origin_buyer_stripe_payment_source?.buyer_stripe_payment_source_id ??
        order?.buyer_stripe_payment_source?.buyer_stripe_payment_source_id ??
        '-'
      "
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <div *ngIf="getCardSource()?.stripe_card as stripe_card; else showDash">
      <app-shared-info
        [label]="'ORDERS.ORIGINAL_CARD_LABEL'"
        [content_class]="'sp-text__ellipsized'"
        [is_update_enabled]="false">
        <div class="sp-row__align">
          <img
            class="sp-margin__right"
            style="padding-bottom: 4px; padding-top: 4px; max-width: 50px; max-height: 16px"
            [src]="getCardLogo(stripe_card.brand)"
            alt="{{ stripe_card.brand }}" />
          <span> {{ stripe_card.funding }} - *{{ stripe_card.last4 }} </span>
        </div>
      </app-shared-info>
    </div>
    <ng-template #showDash>
      <app-shared-info
        [label]="'ORDERS.ORIGINAL_CARD_LABEL'"
        [content_class]="'sp-text__ellipsized'"
        [is_update_enabled]="false"
        [content]="'-'">
      </app-shared-info>
    </ng-template>
    <app-shared-info-copy
      [label]="'ORDERS.CURRENT_CARD_ID_LABEL'"
      [content]="order?.buyer_stripe_payment_source?.buyer_stripe_payment_source_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <div *ngIf="order?.buyer_stripe_payment_source?.stripe_card as stripe_card; else showActDash">
      <app-shared-info
        [label]="'ORDERS.CURRENT_CARD_LABEL'"
        [content_class]="'sp-text__ellipsized'"
        [is_update_enabled]="false">
        <div class="sp-row__align">
          <img
            class="sp-margin__right"
            style="padding-bottom: 4px; padding-top: 4px; max-width: 50px; max-height: 16px"
            [src]="getCardLogo(stripe_card.brand)"
            alt="{{ stripe_card.brand }}" />
          <span> {{ stripe_card.funding }} - *{{ stripe_card.last4 }} </span>
        </div>
      </app-shared-info>
    </div>
    <ng-template #showActDash>
      <app-shared-info
        [label]="'ORDERS.CURRENT_CARD_LABEL'"
        [content_class]="'sp-text__ellipsized'"
        [is_update_enabled]="false"
        [content]="'-'">
      </app-shared-info>
    </ng-template>
    <app-shared-info
      [label]="'ORDERS.CURRENT_CARD_EXP_LABEL'"
      [content]="getCardExp()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info-copy
      [label]="'ORDERS.CURRENT_STRIPE_ID_LABEL'"
      [content]="order?.buyer_stripe_payment_source?.stripe_payment_method_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info-copy
      [label]="'ORDERS.CURRENT_FINGERPRINT_LABEL'"
      [content]="order?.buyer_stripe_payment_source?.stripe_card?.fingerprint || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'ORDERS.PRE_AUTH_DATE_LABEL'"
      [content]="(order?.pre_authorization_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info-copy
      [label]="'ORDERS.PAYMENT_LINK_COLUMN_LABEL'"
      [content]="getPaymentLink()"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true">
    </app-shared-info-copy>
    <app-shared-info
      [label]="'ORDERS.IBAN_LABEL'"
      [content]="order?.buyer_qinetic_payment_source?.qinetic_sepa_debit?.iban || '-'"
      [is_update_enabled]="hasIbanSource()"
      [update_tooltip]="'BUYERS.EDIT_IBAN_CTA'"
      (update_click)="onEditIbanClick()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>

    <app-shared-info
      [label]="'STORES.CARDS_LABEL'"
      [content]="hasCardSource() ? 'BUYERS.EDIT_CREDIT_CARD_CTA' : '-'"
      [is_update_enabled]="hasCardSource()"
      [update_tooltip]="'GENERAL.DELETE_CTA'"
      (update_click)="onDeleteCardClick()"
      [content_class]="'sp-text__ellipsized'">
    </app-shared-info>
  </div>
</div>
